import { PeriodEntity } from 'core/models';
import moment, { Moment } from 'moment';

export class DateUtils {
  static convertEpochToDate(epochTime: number): Date {
    return DateUtils.convertEpochMsToDate(epochTime * 1000);
  }

  static convertEpochMsToDate(epochTime: number): Date {
    const date = new Date(0);
    date.setUTCMilliseconds(epochTime);
    return date;
  }

  static formatedDatetime(date: Date | string): string {
    if (typeof date === 'string') {
      date = DateUtils.parseDateTime(date);
    }
    return date.toLocaleString('tr-TR');
  }

  static now(): Date {
    return new Date();
  }

  static generatePeriodList(from: PeriodEntity, to: PeriodEntity): PeriodEntity[] {
    const periodList = [];
    for (let year = to.year; year >= from.year; year--) {
      let quarter = year === to.year ? to.quarter : 4;
      let firstQuarter = year === from.year ? from.quarter : 1;
      for (; quarter >= firstQuarter; quarter--) {
        periodList.push({ year, quarter });
      }
    }
    return periodList;
  }

  static parseDateTime(date: string): Date {
    return new Date(date);
  }

  static fromNow(startDate: Date | string): string {
    return moment(startDate).fromNow(true);
  }

  static from(startDate: Date | string, endDate: Date | string): string {
    return moment(endDate).from(startDate, true);
  }

  static getEndOfToday(): Moment {
    return moment().hour(23).minutes(59).second(59);
  }
}
